(function () {
  "use strict";

  class TimelineSlider {
    constructor(sliderId, prevBtn, nextBtn, enableAutoplay = true) {
      this.slider = document.getElementById(sliderId);
      this.prevBtn = document.querySelector(prevBtn);
      this.nextBtn = document.querySelector(nextBtn);
      this.currentIndex = 0;
      this.itemsToShow = 2.5;
      this.autoplaySpeed = 5000;
      this.autoplayTimer = null;
      this.isAutoplayActive = enableAutoplay;
      this.updateItemsToShow();

      if (!this.slider || !this.prevBtn || !this.nextBtn) return;

      this.init();
    }

    updateItemsToShow() {
      if (window.innerWidth < 750) {
        this.itemsToShow = 1;
      } else if (window.innerWidth < 1024) {
        this.itemsToShow = 1;
      } else {
        this.itemsToShow = 2.5;
      }
    }

    init() {
      this.prevBtn.addEventListener("click", () =>
        this.handleUserInteraction("prev"),
      );
      this.nextBtn.addEventListener("click", () =>
        this.handleUserInteraction("next"),
      );
      document.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") this.handleUserInteraction("prev");
        if (e.key === "ArrowRight") this.handleUserInteraction("next");
      });
      window.addEventListener("resize", () => this.onResize());

      const container = this.slider.closest(".timeline");
      if (container) {
        container.addEventListener("mouseenter", () => this.pauseAutoplay());
        container.addEventListener("mouseleave", () => this.resumeAutoplay());
      }

      this.updateSlide();
      this.startAutoplay();
    }

    handleUserInteraction(direction) {
      this.pauseAutoplay();
      if (direction === "prev") {
        this.prev();
      } else {
        this.next();
      }
      this.resumeAutoplay();
    }

    startAutoplay() {
      if (this.isAutoplayActive) {
        this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
      }
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    resumeAutoplay() {
      if (this.isAutoplayActive) {
        this.startAutoplay();
      }
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlide();
      }
    }

    next() {
      const slides = this.slider.querySelectorAll(".timeline__slide");
      const maxIndex = Math.max(0, slides.length - Math.ceil(this.itemsToShow));
      if (this.currentIndex < maxIndex) {
        this.currentIndex++;
        this.updateSlide();
      }
    }

    updateSlide() {
      const slides = this.slider.querySelectorAll(".timeline__slide");
      if (slides.length === 0) return;

      const slideWidth = slides[0].offsetWidth;
      const gap = parseInt(window.getComputedStyle(this.slider).gap) || 0;
      const offset = -(this.currentIndex * (slideWidth + gap));
      this.slider.style.transform = `translateX(${offset}px)`;

      // Update arrow disabled states
      const maxIndex = Math.max(0, slides.length - Math.ceil(this.itemsToShow));
      this.prevBtn.disabled = this.currentIndex === 0;
      this.nextBtn.disabled = this.currentIndex === maxIndex;
    }

    onResize() {
      const prevItemsToShow = this.itemsToShow;
      this.updateItemsToShow();

      if (prevItemsToShow !== this.itemsToShow) {
        this.currentIndex = 0;
        this.updateSlide();
      }
    }
  }

  // Initialize all timeline sliders
  document.addEventListener("DOMContentLoaded", function () {
    Object.keys(window.timelineSliders || {}).forEach(function (sectionId) {
      const config = window.timelineSliders[sectionId];
      new TimelineSlider(
        config.sliderId,
        config.prevBtn,
        config.nextBtn,
        config.enableAutoplay,
      );
    });
  });
})();
